import { render } from "./BarChart.vue?vue&type=template&id=7c3303a3"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dongan_teens2_check/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__